window.addEventListener("DOMContentLoaded", (ev) => {
  const swiper = new Swiper(".section__slideshow", {
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    loop: true,
    pagination: {
      el: ".slideshow__navigation",
      clickable: true,
    },
  });

  const slideshows = document.querySelectorAll(".section__slideshow");
  const hasAnnouncement = document.querySelector(".announcement-bar-section");

  if (hasAnnouncement) {
    slideshows.forEach((slideshow) => {
      slideshow.classList.add("has-announcement");
    });
  }
});
